/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_TitleInputs */

const en_coaching_title = /** @type {(inputs: Coaching_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1-on-1 coaching`)
};

const id_coaching_title = /** @type {(inputs: Coaching_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaching 1-on-1`)
};

/**
* | output |
* | --- |
* | "1-on-1 coaching" |
*
* @param {Coaching_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_title = /** @type {((inputs?: Coaching_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_title(inputs)
	return en_coaching_title(inputs)
});